export default {
  index: "",
  login: "Login",
  "hospital-list": "Manage Hospitals",
  "transplant-list": "Organ License List",
  "user-list": "User List",
  "temporary-license-list": "Temporary License List",
  "hospital-registration": "Hospital Registration",
  "update-hospital": "Update Hospital",
  "update-transplant-license": "Update Organ License",
  "transplant-registration": "Organ License Registration",
  "live-transplant-registration": "Live Transplant Registration",
  "update-transplant-registration": "Update Live Transplant",
  registration: "Registration",
  "manage-recipient": "Manage Recipient",
  "recipient-registration": "Recipient Registration",
  "update-recipient": "Update Recipient",
  "manage-donor": "Manage Donor",
  "donor-registration": "Donor Registration",
  "update-donor": "Update Donor",
  "recipient-transfer": "Recipient Transfer",
  "tnos-waiting-list": "Sotto Waiting List",
  "hospital-waiting-list": "Hospital Waiting List",
  "cm-insurance-list": "CM Insurance List",
  "live-transplant": "Live Transplant",
  "liver-urgent-listing": "Supra Urgent Listing",
  "manage-alf-approver": "Supra Urgent Approver",
  "create-alf": "Create Supra Urgent",
  "update-alf": "Update Supra Urgent",
  "manage-alf": "Supra Urgent Listing",
  reports: "Reports",
  masters: "Masters",
  "user-management": "User Management",
  "sotto-management": "Sotto Management",
  "organ-allocation": "Organ Allocation",
  "in-house-waiting-list": "Inhouse Waiting List",
  "be-ready-list": "Be Ready List",
  "recipient-pending-approval": "Recipient Pending Approval",
  "hospital-rota-order": "Liver Rota Order",
  "donor-pledge": "Donor Pledge Form",
  "organ-allocation-overall-report": "Organ Allocation Report",
  "donor-identification": "Donor Identification",
  "create-donor-identification": "Create Donor Identification",
};
